module.exports = __webpack_public_path__ + "img/nru.d16edc69.svg";